<!-- Vaste volgorde door de hele app: feature-eigen extra-knoppen links, dan edit (2e van rechts),
     dan delete (uiterst rechts) — zo staan de standaard-acties altijd op dezelfde plek. -->
<ng-container *ngTemplateOutlet="input_templateExtraButtons$$()"></ng-container>
<!-- @if (hasEditSection$$()) { -->
@if (btnEditShow$$()) {
    <app-button-action
        (btnClick)="emit_btnEdit()"
        [buttonData]="btnEditData$$()"
        [loadKey]="loadKey.pageLock"
        [lockOnLoad]="input_lockOnLoad$$()"
        [tooltip]="btnEditTooltip$$()"
        >
        <app-icon name="edit" [@show] />
    </app-button-action>
}
<!-- } -->
<!-- Delete als laatste (uiterst rechts): destructieve actie. Heeft een bevestigingsdialoog (zie emit_btnDelete). -->
@if (btnDeleteShow$$()) {
    <app-button-action
        (btnClick)="emit_btnDelete();"
        [buttonData]="btnDeleteData$$()"
        [loadKey]="loadKey.pageLock"
        [lockOnLoad]="input_lockOnLoad$$()"
        [tooltip]="btnDeleteTooltip$$()"
        >
        <app-icon name="trash" [@show] />
    </app-button-action>
}

